import {
  CommonButton,
  ImageElement,
  RippleEffect,
  SweetAlert,
  textFormatter,
} from "components";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
// import routesMap from "routeControl/userRouteMap";
import { useMemo, useState } from "react";
import { CommonApi, MyBiographiesServices } from "services";
import {
  decoder,
  encoder,
  logger,
  modalNotification,
  setSessionStorage,
} from "utils";
import routesMap from "routeControl/userRouteMap";
import { useSelector } from "react-redux";
import { selectUserData } from "redux/AuthSlice/index.slice";
import DropDownComponent from "components/UiElement/DropDownComponent";

function NavbarSection03({
  offset,
  scrolltopdata,
  t,
  isUser,
  memorialData,
  getMemorialData,
  userId,
  isModal,
  capturedData,
  familyTreeData,
  timelineData,
  setShareModal,
}) {
  const [isActive, setIsActive] = useState(false);
  const userData = useSelector(selectUserData);
  const isEmail = textFormatter(userData?.email);
  const navigate = useNavigate();
  const [publishAlert, setPublishAlert] = useState(false);
  const [publishedId, setPublishedId] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const { id } = useParams();
  const onHandlePublished = (publishId) => {
    setPublishAlert(true);
    setPublishedId(publishId);
  };

  const onPublish = async (publishId) => {
    try {
      const res = await MyBiographiesServices?.biographyPublish(publishId);
      const { success, message } = res;
      if (success) {
        modalNotification({ type: "success", message });
        getMemorialData("theme03");
        setPublishedId("");
      }
    } catch (error) {
      logger(error);
    }
  };

  const isEdits = useMemo(() => {
    const specificEmail = memorialData?.memorialUserPermissions?.find(
      (item) => {
        return textFormatter(item?.email) === isEmail;
      }
    );
    return specificEmail;
  }, [memorialData, isEmail]);

  const dorpDowns = () => {
    let arr = [];
    if (
      (isEdits?.edit === 1 &&
        memorialData?.memorialUserPermissions?.length > 0) ||
      memorialData?.userId === userId
    ) {
      arr.splice(0, 0, {
        name: t("text.common.edit"),
        onClicks: () => {
          navigate(
            `${routesMap?.CREATEMEMORIALS?.path}/${encoder(
              memorialData?.id
            )}?${encoder(memorialData?.themeOnes?.[0]?.type)}`
          );
          setSessionStorage("steps", 1);
          setSessionStorage(
            "theme",
            memorialData?.themeOnes?.[0]?.type || "theme02"
          );
        },
        icon: "icon-edit",
        theme: "theme01",
      });
    }
    if (memorialData?.userId !== userId) {
      arr.splice(1, 1, {
        name: memorialData?.isSaved === false ? "Save" : "Unsave",
        onClicks: () => {
          setIsAlertVisible(true);
        },
        icon: "icon-saved",
      });
    }
    if (memorialData?.status !== "published") {
      arr.splice(2, 0, {
        name: t("text.common.close"),
        path: routesMap?.MYBIOGRAPHIES?.path,
        icon: "icon-close",
      });
    }
    return arr;
  };

  const handleDelete = async (memorialId) => {
    try {
      await CommonApi.saveUnSaveBiography(memorialId);
      getMemorialData();
    } catch (error) {
      logger(error);
    }
  };

  const handleClose = () => {
    setIsActive(false);
    document.querySelector("body").style.overflow = `auto`;
  };
  const toggleClass = () => {
    setIsActive(!isActive);
    document.querySelector("body").style.overflow = `hidden`;
  };
  return (
    <>
      <header className="theme03Header">
        <Navbar fixed="top" expand={false} className={`${scrolltopdata}`}>
          <Container className="d-block">
            <div className="d-flex align-items-center justify-content-between">
              <Link
                to={
                  isModal || !isUser
                    ? routesMap.HOME.path
                    : routesMap.USERDASHBOARD.path
                }
                className="navbar-brand flex-grow-1 flex-lg-grow-0 p-0"
              >
                <ImageElement
                  source="theme-logo.svg"
                  className="lightLogo"
                  alt="logo"
                />
                <ImageElement
                  source="logo.svg"
                  className="darkLogo"
                  alt="logo"
                />
              </Link>
              <div className={`overlay ${isActive ? "open" : ""}`}>
                <div className="layout d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <Link
                      to={isModal ? "#" : routesMap.USERDASHBOARD.path}
                      className="navbar-brand flex-grow-1 flex-lg-grow-0 p-0"
                    >
                      <ImageElement
                        source="theme-logo.svg"
                        className=""
                        alt="logo"
                      />
                    </Link>
                    <Link to="#" onClick={handleClose} className="close-button">
                      <div className="in">
                        <div className="close-button-block" />
                        <div className="close-button-block" />
                      </div>
                      <div className="out">
                        <div className="close-button-block" />
                        <div className="close-button-block" />
                      </div>
                    </Link>
                  </div>
                  <div className="menuLinks">
                    <Nav className="d-flex flex-grow-1 overlay--menu">
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="about"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">About</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                      {capturedData?.length > 0 && (
                        <ScrollLink
                          activeClass="active"
                          className="nav-link"
                          to="gallery"
                          spy
                          smooth
                          offset={-offset}
                          duration={800}
                          onClick={handleClose}
                        >
                          <p className="link">Gallery</p>
                          <span className="clickLink">Click Here</span>
                        </ScrollLink>
                      )}
                      {timelineData?.length > 0 && (
                        <ScrollLink
                          activeClass="active"
                          className="nav-link"
                          to="timeline"
                          spy
                          smooth
                          offset={-offset}
                          duration={800}
                          onClick={handleClose}
                        >
                          <p className="link">Timeline</p>
                          <span className="clickLink">Click Here</span>
                        </ScrollLink>
                      )}
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="story"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">Story</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                      {familyTreeData?.length > 0 && (
                        <ScrollLink
                          activeClass="active"
                          className="nav-link"
                          to="familytree"
                          spy
                          smooth
                          offset={-offset}
                          duration={800}
                          onClick={handleClose}
                        >
                          <p className="link">Family Tree</p>
                          <span className="clickLink">Click Here</span>
                        </ScrollLink>
                      )}
                    </Nav>
                  </div>
                  <ul className="list-unstyled d-sm-flex social flex-shrink-0 position-relative justify-content-center">
                    {memorialData?.instagram && (
                      <li>
                        <Link
                          to={memorialData?.instagram}
                          target="_blank"
                          aria-label="facebook"
                        >
                          Instagram <em className="icon-arrow-right" />
                        </Link>
                      </li>
                    )}

                    {memorialData?.twitter && (
                      <li>
                        <Link
                          aria-label="twitter"
                          to={memorialData?.twitter}
                          target="_blank"
                        >
                          Twitter <em className="icon-arrow-right" />
                        </Link>
                      </li>
                    )}

                    {memorialData?.facebook && (
                      <li>
                        <Link
                          aria-label="facebook"
                          to={memorialData?.facebook}
                          target="_blank"
                        >
                          Facebook <em className="icon-arrow-right" />
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                {!isModal && (
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className={`menuIcon btn open-menu ${isActive ? "active" : ""
                      }`}
                    onClick={() => {
                      if (!isModal) {
                        toggleClass();
                      }
                    }}
                  >
                    <div className="menuIcon_inner d-flex align-items-center justify-content-between">
                      <span>Menu</span>
                      <em className="icon-dots ms-sm-2 d-none d-sm-block" />
                    </div>
                  </Navbar.Toggle>
                )}
                {isUser && (
                  <>
                    {!isModal && (
                      <DropDownComponent
                        items={dorpDowns()}
                        theme="theme03"
                        centerClass="btnCenter"
                        extraClassName="btn-gradiant btn-gradiant-white position-relative"
                      />
                    )}
                    {userId === memorialData?.userId &&
                      memorialData?.status !== "published" &&
                      !isModal ? (
                      <RippleEffect extraClassName="btnCenter">
                        <CommonButton
                          className="btn-gradiant position-relative w-auto"
                          variant="outline-white"
                          onClick={() => {
                            if (memorialData?.status !== "published")
                              onHandlePublished(memorialData?.id);
                          }}
                        >
                          {/* <em className="icon-saved me-sm-2" />
                          <span className="d-none d-sm-block"> */}
                          Publish
                          {/* </span> */}
                        </CommonButton>
                      </RippleEffect>
                    ) : (
                      <>
                        <RippleEffect extraClassName="btnCenter">
                          <CommonButton
                            variant="danger"
                            className="btn-gradiant btn btn-none"
                            onClick={() => setShareModal(true)}
                          >
                            <em className="icon-share me-sm-2" />
                            <span className="d-none d-sm-block">Share</span>
                          </CommonButton>
                        </RippleEffect>
                        {/* <RippleEffect extraClassName="btnCenter">
                          <CommonButton
                            to={routesMap.USERDASHBOARD.path}
                            className="btn-gradiant btn-gradiant-white position-relative backBtn"
                          >
                            <em className="icon-arrow-prev me-sm-2" />
                            <span className="d-none d-sm-block">Back</span>
                          </CommonButton>
                        </RippleEffect> */}
                      </>
                    )}
                  </>
                )}
                {/* <RippleEffect extraClassName="btnCenter">
                  <CommonButton
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(routesMap.USERDASHBOARD.path);
                    }}
                    className="btn-gradiant btn-gradiant-white position-relative backBtn"
                  >
                    <em className="icon-arrow-prev me-sm-2" />
                    <span className="d-none d-sm-block">Back</span>
                  </CommonButton>
                </RippleEffect> */}
                {/* <RippleEffect extraClassName="btnCenter">
                  <CommonButton
                    className="btn-gradiant btn-gradiant-white position-relative"
                  >
                    <em className="icon-edit me-sm-2" />
                    <span className="d-none d-sm-block">Edit</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect>
                  <CommonButton
                    className="btn-gradiant"
                  >
                    <span>Publish</span>
                  </CommonButton>
                </RippleEffect> */}
              </div>
            </div>
          </Container>
        </Navbar>
      </header>

      <SweetAlert
        reverseButtons
        title={
          memorialData?.isSaved === true
            ? t("text.biographies.unSaveBiography")
            : t("text.biographies.saveBiography")
        }
        text={
          memorialData?.isSaved === true
            ? t("text.biographies.areYouSureUnSaveBiography")
            : t("text.biographies.areYouSureSaveBiography")
        }
        show={isAlertVisible}
        icon="question"
        showCancelButton
        setIsAlertVisible={setIsAlertVisible}
        onConfirmAlert={() => handleDelete(decoder(id))}
      />

      <SweetAlert
        text="Are you sure you want to publish?"
        show={publishAlert}
        icon="question"
        showCancelButton
        confirmButtonText="Publish Now"
        cancelButtonText="Cancel"
        setIsAlertVisible={setPublishAlert}
        onConfirmAlert={() => onPublish(publishedId)}
      />
    </>
  );
}

export default NavbarSection03;
